<template>
  <table class="tbl">
    <slot name="colgroup"/>
    <thead>
    <tr>
      <th v-for="(item, index) in headers" :key="index"
          :class="[`data-${item.value}`, { 'first-item': index === 0, 'txt-left': item.alignLeft, 'sortable': item.sortable }, $i18n.locale]">
          <span v-if="item.tooltip" class="tooltip" v-btf-tooltip="{ contents: item.tooltip }">
            <i class="icon icon--info-white size-16"></i>
          </span>
        <span v-html="item.name"/>
        <button v-if="item.sortable"
                class="sort"
                @click="changeSort(item.value)"
                :class="{ active: sort === item.value || sort === '-'+item.value,
                                asc: order,
                                desc: !order }">

          <i class="icon icon--sort-asc"></i>
          <i class="icon icon--sort-desc"></i>
        </button>
        <slot v-if="item.inReady" name="inReady"></slot>
      </th>
    </tr>
    </thead>
    <slot/>
  </table>
</template>

<script>
export default {
  name: 'AppTable',
  props: [
    'headers',
    'sortColumn',
    'isSortAsc',
    'sortType'
  ],
  data () {
    return {
      sort: this.sortType,
      headerList: this.headers.map(item => {
        return {
          ...item,
          showSortOption: false
        }
      })
    }
  },
  computed: {
    order () {
      return !this.sort.includes('-')
    }
  },
  methods: {
    changeSort (value) {
      if (this.sort === value) {
        this.sort = '-' + value
      } else if (this.sort === '-' + value) {
        this.sort = value
      } else {
        this.sort = '-' + value
      }
      this.$emit('changeSort', this.sort)
    },
    onSortItemClick (item, isAsc) {
      this.$emit('onSortOptionChange', item.sortColumn, isAsc)
      item.showSortOption = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  thead {
    tr {
      background-color: #555;
      .btn_sort {
        position: absolute;
        top: 50%;
        right: -20px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
    }
    th {
      position: relative;
      height: 50px;
      color: #fff;
      line-height: 1.23;
      & span {
        display: inline-block;
        vertical-align: middle;
      }
      .tooltip {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }

      .sort {
        display: inline-block;
        width: 14px;
        height: 18px;
        margin-left: 5px;
        vertical-align: middle;
        border-radius: 4px;
        transition: background-color 0.15s ease,
        box-shadow 0.15s ease;

        i.icon {
          float: left;
          opacity: 0.2;
          transition: opacity 0.15s ease;
        }

        &.gap {
          padding: 0;
          width: 25px;
          border-bottom: none;
        }

        &.active {
          &.asc {
            .icon--sort-asc {
              opacity: 1;
            }
          }

          &.desc {
            .icon--sort-desc {
              opacity: 1;
            }
          }
        }

        &.active {
          background-color: #272727;
          box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
        }
      }
      &:first-of-type:before,
      &:last-of-type:before {
        content: "";
        display: inline-block;
        width: 15px;
        height: 50px;
        position: absolute;
        top: 0;
        left: -5px;
        background-color: #555;
        border-radius: 5px;
      }

      &:last-of-type:before {
        left: auto;
        right: -5px;
      }

      .inner_item {
        position: relative;
        line-height: 16px;
        display: inline-block;
      }
      .sort_item {
        overflow: hidden;
        position: absolute;
        top: -23px;
        left: 100%;
        min-width: 140px;
        border-radius: 6px;
        box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
          0 0 0 1px rgba(0, 0, 0, 0.25);
        background-color: #fff;
        z-index: 99;
        .sort_order {
          width: 100%;
          display: inline-block;
          line-height: 32px;
          padding-left: 8px;
          padding-right: 8px;
          text-align: left;
          white-space: nowrap;
          &:before {
            display: inline-block;
            content: "";
            width: 16px;
            height: 16px;
            margin: 9px 5px 0 0;
            background-image: url(../../assets/img/icon_sort_asc.svg);
            vertical-align: top;
          }
          &:hover {
            background-color: #ebebeb;
          }
          &.on {
            background-color: #fff;
            color: $brandColor;
            font-weight: 500;
            pointer-events: none;
            &:before {
              background-image: url(../../assets/img/icon_sort_asc_on.svg);
            }
          }
        }
        .sort_order2 {
          &:before {
            background-image: url(../../assets/img/icon_sort_desc.svg);
          }
          &.on:before {
            background-image: url(../../assets/img/icon_sort_desc_on.svg);
          }
        }
      }
    }
  }
  .txt-left {
    text-align: left;
    padding-left: 10px;
  }
  .first-item {
    padding-left: 10px;
  }
  .sortable {
    padding-left: 10px;
  }
}
</style>
